import { useTexture } from '@react-three/drei'

export default function Floor()
{
    const texture = useTexture('./textures/room/concrete_floor_painted/concrete_floor_painted_diff_1k.jpg')
    // const texture = useTexture('./textures/room/marble_tiles/marble_tiles_diff_1k.jpg')
    // const texture = useTexture('./textures/room/rusty_metal_03/rusty_metal_03_diff_1k.jpg')

    return <>
    
        {/* Floor */}
        <mesh 
            receiveShadow
            position-y={-2}
            rotation-x={ - Math.PI * 0.5 } 
        >
            <planeGeometry args={[4,4]} />
            <meshStandardMaterial 
                map={texture}
            />
        </mesh>
    </>   
}